// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store/index";
import service from "./service/Service";
import iView from "view-design";
import "view-design/dist/styles/iview.css";
import VueAwesomeSwiper from "vue-awesome-swiper/dist/vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "./assets/style/style.less";
import VueFriendlyIframe from "vue-friendly-iframe";
import "jquery";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import qs from "qs";
import utils from "./utils/utils";
import gaAction from "./utils/gaType";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import zoomOnHover from "vue-zoom-on-hover";
import "../src/utils/zoomOnHover.css";

import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "../src/utils/zoomOnHover.css";
import MetaInfo from "vue-meta-info";
import * as vClickOutside from 'v-click-outside-x';
import  FastClick  from  'fastclick'
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo)
FastClick.attach(document.body);
Vue.use(vClickOutside);

import animated from 'animate.css'
Vue.use(animated)
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)
router.afterEach((to, from, next) => {
  setTimeout(()=>{ 
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");

      if(process.env.ENV_CONFIG == "prod"){
        hm.src = "https://hm.baidu.com/hm.js?9febd97bc3633be2f4ae9908bce5267b";
      }else{
        hm.src = "https://hm.baidu.com/hm.js?e6926efbf0197fe5dc898d4ca44f6178";
      }
      
      var s = document.getElementsByTagName("script")[0]; 
      s.parentNode.insertBefore(hm, s);
    })();
  },0);
 
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title_zh) {
    document.title = to.meta.title_zh("zh");
  }
  window.scrollTo(0, 0);
  if (to.path.indexOf("/account") > -1 && !to.name == "faqValue") {
    let token = window.localStorage.getItem("token");
    if (token === null || token === "") {
      next("/login");
    } else {
      next();
    }
  }else if (to.path.indexOf("login") > -1) {
    let token = window.localStorage.getItem("token");
    if (token) {
      next("/account/user-info");
    } else {
      next();
    }
  } else {
    next();
  }
});

Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$service = service;

Vue.use(service);
Vue.use(iView);
Vue.use(zoomOnHover);
Vue.use(VueAwesomeSwiper);
Vue.component("vue-friendly-iframe", VueFriendlyIframe);
Vue.use(MetaInfo);

Vue.prototype.$utils = utils;
Vue.prototype.$gaAction = gaAction;

import 'intersection-observer'
import IsIntersecting from "vue-is-intersecting";
Vue.use(IsIntersecting);

Vue.config.productionTip = false;
Vue.filter("capitalize", function(num, point) {
  num = parseFloat(num).toFixed(2);
  var point = point || 2;
  var sInt, sFloat;
  if (typeof num === "number" && num % 1 === 0) {
    sInt = num;
    var reg = getRegExp("d(?=(d{3})+$)", "g");
    sInt = (sInt + "").replace(reg, "$&,");
  } else {
    var curnum = (num + "").split(".");
    var reg = getRegExp("d(?=(d{3})+$)", "g");

    sInt = curnum[0].replace(reg, "$&,");
    sFloat = curnum[1];
  }
  return sFloat ? sInt + "." + sFloat : sInt;
});
//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive("real-img", async function(el, binding) {
  //指令名称为：real-
  let flag = utils.check_support_webp();
  let imgURL = flag ? binding.value + "?x-oss-process=style/tb" : binding.value; //获取图片地址
  if (imgURL) {
    el.setAttribute("class", "unimgloaded");
    let exist = await utils.imageIsExist(imgURL);
    if (exist) {
      el.setAttribute("src", imgURL);
      el.setAttribute("class", "imgloaded");
    } else {
      el.setAttribute("src", imgURL);
      el.setAttribute("class", "imgloaded");
    }
  }
});
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   store,
//   components: { App },
//   template: '<App/>'
// })

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event("custom-render-trigger"));
  },
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js